import { useEffect, useState } from "react";
import { Category } from "../../components/products-page/components/products-categories/models/Category.model";
import { getFixcenterCategories } from "../../services/products.service";
import { ProductFilter } from "../../components/product-filters-menu/models/product-filter.model";
import { FixcenterFilterDto } from "../../components/product-filters-menu/models/fixcenter-filter-dto.model";
import React from "react";
import { Box, Container, Stack, Typography, Avatar, Skeleton } from "@mui/material";
import * as authService from '../../auth/services/auth.service';
import { useNavigate } from "react-router-dom";
import { Utils } from "../../shared/constants/utilities.constants";
import { getProductImageUrl } from "../../shared/services/get-attachments.service";

export default function ProductsFirstLevel() {

    const [mainCategories, setMainCategories] = useState<Category[]>([]);
    const guidEmpty = "00000000-0000-0000-0000-000000000000";
    const [isSkeletonLoader, setIsSkeletonLoader] = useState<boolean>(false);
    const navigate = useNavigate();

    const fetchCategories = async () => {
        setIsSkeletonLoader(true);
        const languageCode = localStorage.getItem("lang");
        const productFilter: ProductFilter = {
            isCategory: true,
            parentProductId: guidEmpty,
        }

        const fixcenterFilter: FixcenterFilterDto = {
            productFilter: productFilter,
        }

        if (languageCode) {
            fixcenterFilter.languageCode = languageCode;
        }

        try {
            getFixcenterCategories(fixcenterFilter).then((response: any) => {
                if (response) {
                    const categoriesResponse = response.data as Category[];
                    setMainCategories(categoriesResponse);
                    setIsSkeletonLoader(false);
                }
            })
        } catch (error) {
            console.error(error);
            setIsSkeletonLoader(false);
        }
    };

     const goToCategory = (category: Category): void => {
        if (checkIfIsLoggedIn()) {
            navigate(`/webshop/category/${category.name}/${category.id}`);
        } else {
            navigate('/login');
        }
    }

    const checkIfIsLoggedIn = (): boolean => {
        const isLoggedIn: boolean = authService.checkLogInStatus();
        return isLoggedIn
    }
    

    useEffect(() => {
        fetchCategories();
    }, []);

  return (
        <React.Fragment>
            <Container
                maxWidth={false}
                sx={{
                    mt: 2,
                    mb: 4,
                    px: { xs: 2, md: 4, lg: 10, xl: 20 }
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        gap: 2,
                        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                        justifyItems: "center"
                    }}
                >
                {isSkeletonLoader ? 
                <React.Fragment>
                    {Array.from({ length: 18 }).map((_, i) => (
                        <Stack spacing={1} alignItems="center" sx={{ p: 1 }} key={i}>
                            <Skeleton
                                variant="circular"
                                width={180}
                                height={180}
                            />
                            <Skeleton
                                variant="rectangular"
                                width={120}
                                height={20}
                                sx={{ borderRadius: 1 }}
                            />
                        </Stack>
                    ))}
                </React.Fragment>
                :
                <React.Fragment>
                    {mainCategories.map((c) => {
                        const imgId = c.imageIds?.find((id) => id && id !== Utils.defaultUuid);

                        return (
                            <Stack
                                key={c.id}
                                spacing={1}
                                alignItems="center"
                                onClick={() => goToCategory(c)}
                                sx={{
                                cursor: "pointer",
                                p: 1,
                                borderRadius: 2,
                                transition: "0.2s",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 180,
                                        height: 180,
                                        borderRadius: "50%",
                                        bgcolor: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: 5
                                    }}
                                > 
                                <Avatar
                                    src={imgId ? getProductImageUrl(imgId) : undefined}
                                    sx={{ width: 155, height: 155 }}
                                />
                                </Box>

                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 600,
                                        textAlign: "center",
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                        lineHeight: 1.2,
                                        marginTop: "20px !important"
                                    }}
                                >
                                {c.translation || c.name}
                                </Typography>
                            </Stack>
                        );
                    })}
                </React.Fragment>
                }
                </Box>
            </Container>
        </React.Fragment>
    ); 
}
